import { useTheme } from '@vebox/etui-system';
import '../../utilities/format-ms.js';
import '../../utilities/create-transition.js';
import { useContext, createElement, Fragment } from 'react';
import '../../utilities/get-styleprop.js';
import '../../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import '../../Svg-0180d7b5.js';
import '../../Icon/Icon.js';
import '@vebox/etui-icons';
import '../../Icon/icons.js';
import '../../Icon/helper.js';
import '@vebox/etui-colors';
import '../../ClickOutside/ClickOutside.js';
import '../../Tooltip/Tooltip.js';
import '../../Button/Button.js';
import '../../Chip/Chip.js';
import 'lodash.isnil';
import { getFilterPanelChipContent } from '../utils.js';
import '../state/constants.js';
import { removeValue } from '../state/actions.js';
import FilterPanelContext from '../FilterPanelContext.js';
import SummarySectionChip from './SummarySectionChip.js';

const FilterChips = ({
  filters,
  fieldsMetadata
}) => {
  const theme = useTheme();
  const {
    dispatch
  } = useContext(FilterPanelContext);
  return /*#__PURE__*/createElement(Fragment, null, Object.entries(filters).flatMap(([field, values]) => {
    if (Array.isArray(values)) {
      return values.map((value, i) => /*#__PURE__*/createElement(SummarySectionChip, {
        key: `${field}-${i}`,
        content: getFilterPanelChipContent({
          field,
          value,
          fieldsMetadata,
          theme
        }),
        onRemove: () => {
          dispatch(removeValue(field, value));
        }
      }));
    }
    return /*#__PURE__*/createElement(SummarySectionChip, {
      key: field,
      content: getFilterPanelChipContent({
        field,
        value: values,
        fieldsMetadata,
        theme
      }),
      onRemove: () => {
        dispatch(removeValue(field));
      }
    });
  }));
};

export default FilterChips;
